import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const TableBadgeLabelWrapper = styled.div`
  margin-right: ${Spacing.S8};
`
